import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search, X } from 'lucide-react';
import { QUICK_FILTERS, PRIORITY } from './crmUtils';

const ALL = '__all';

export function LeadFilters({ f, setF, stages, sellers, kpis }) {
  const sel = (key, placeholder, opts, testId) => (
    <Select value={f[key] || ALL} onValueChange={v => setF({ ...f, [key]: v === ALL ? '' : v })}>
      <SelectTrigger className="h-8 w-auto min-w-[120px] text-xs" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>{placeholder}</SelectItem>
        {opts.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
  );
  const count = (k) => (kpis && kpis[k] ? kpis[k].length : null);
  return (
    <div className="space-y-2 mb-3" data-testid="lead-filters">
      <div className="flex flex-wrap gap-1.5">
        {QUICK_FILTERS.map(q => (
          <button key={q.key} type="button" onClick={() => setF({ ...f, quick: f.quick === q.key ? '' : q.key })} data-testid={`quick-${q.key}`}
            className={`px-2.5 py-1 rounded-full text-xs border transition-colors ${f.quick === q.key ? 'bg-slate-900 text-white border-slate-900 dark:bg-white dark:text-slate-900' : 'bg-card hover:bg-accent'}`}>
            {q.label}{count(q.key) !== null ? ` (${count(q.key)})` : ''}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <div className="relative">
          <Search className="absolute left-2 top-2 h-3.5 w-3.5 text-muted-foreground" />
          <Input className="h-8 pl-7 w-56 text-xs" placeholder="Sök skola, kommun, kontakt..." value={f.search} onChange={e => setF({ ...f, search: e.target.value })} data-testid="lead-search" />
        </div>
        {sel('stage', 'Alla statusar', stages.map(s => [s.value, s.label]), 'filter-stage')}
        {sel('priority', 'Alla prioriteter', Object.entries(PRIORITY).map(([k, v]) => [k, v.label]), 'filter-priority')}
        {sel('owner', 'Alla säljare', sellers.map(s => [s.id, s.name || s.email]), 'filter-owner')}
        <Input className="h-8 w-28 text-xs" type="number" min="0" placeholder="Min sensorer" value={f.minSensors} onChange={e => setF({ ...f, minSensors: e.target.value })} data-testid="filter-min-sensors" />
        <Input className="h-8 w-32 text-xs" type="number" min="0" placeholder="Min värde (kr)" value={f.minValue} onChange={e => setF({ ...f, minValue: e.target.value })} data-testid="filter-min-value" />
        <label className="flex items-center gap-1 text-xs text-muted-foreground">Uppföljning senast
          <Input className="h-8 w-36 text-xs" type="date" value={f.followBefore} onChange={e => setF({ ...f, followBefore: e.target.value })} data-testid="filter-follow-before" />
        </label>
        {Object.values(f).some(Boolean) && (
          <button className="text-xs text-muted-foreground flex items-center gap-1 hover:text-foreground" onClick={() => setF({ search: '', quick: '', stage: '', priority: '', owner: '', minSensors: '', minValue: '', followBefore: '' })} data-testid="filter-clear">
            <X className="h-3 w-3" /> Rensa
          </button>
        )}
      </div>
    </div>
  );
}
